import psHttp from '@patsnap/common-ps-http';
import _ from 'lodash';
import qs from 'qs';
import { baseAuthServer, baseUserServer, } from '../../config/apiConfig';
import { E_LanguageLong } from '../passport/types';
/**
 * 重置密码 并登录
 */
export function postUpdatePasswordLogin(params) {
    return psHttp({
        url: `${baseAuthServer}/update-password-login`,
        method: 'POST',
        withCredentials: true,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: qs.stringify({ ...params }),
    }).then(res => {
        return _.get(res, 'data');
    });
}
/**
 * 重置密码不登录
 */
export function postResetPassword(params) {
    return psHttp({
        url: `${baseAuthServer}/public/api/update_password`,
        method: 'POST',
        params: {
            ...params,
            isReset: true,
        },
    });
}
/**
 * 激活重置密码
 */
export function postUpdatePassword(params) {
    return psHttp({
        url: `${baseAuthServer}/public/api/update_password`,
        method: 'POST',
        withCredentials: true,
        params,
    }).then(res => {
        return _.get(res, 'data');
    });
}
/**
 * 重置密码页检测token 是否过期
 */
export function getUpdatePasswordLoginCheck(token) {
    return psHttp({
        url: `${baseAuthServer}/update-password-login/check`,
        params: { token },
    }).then(res => {
        return _.get(res, 'data');
    });
}
/**
 * 更新sso用户信息
 */
export function postSamlUserComplate(params) {
    return psHttp({
        url: `${baseAuthServer}/saml/user/complete`,
        method: 'POST',
        withCredentials: true,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: qs.stringify({ ...params }),
    }).then(res => {
        return _.get(res, 'data');
    });
}
/**
 * 发送邮箱验证码
 */
export function postEmailVerifyCodeApi(params, resGeetestValidate) {
    return psHttp({
        url: `${baseAuthServer}/public/email/verify-code`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: qs.stringify({
            email: params.email,
            purpose: params.purpose,
            language: E_LanguageLong[params.lang || 'cn'],
            ...resGeetestValidate,
        }),
    }).then(res => {
        return _.get(res, 'data');
    });
}
/**
 * 获取wx.config配置信息
 */
export function getWechatEnterpriseApi(params) {
    return psHttp({
        url: `${baseUserServer}/user-service/wechat-enterprise/js/config`,
        method: 'GET',
        params,
    }).then(res => {
        return _.get(res, 'data');
    });
}
/**
 * 获取wx.config配置信息
 */
export function getFeiShuConfigApi(params) {
    return psHttp({
        url: `${baseUserServer}/user-service/feishu/js/config`,
        method: 'GET',
        params,
    }).then((res) => {
        return _.get(res, 'data');
    });
}
/**
 * 通过第三方code登录
 */
export function getTokenByThirdPartyCodeApi(type, data) {
    return psHttp({
        url: `${baseAuthServer}/login/${type}/code`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        withCredentials: true,
        data: qs.stringify(data),
    }).then(res => {
        return _.get(res, 'data');
    });
}
/**
 * 登陆检查
 */
export function preLogin(type, data) {
    return psHttp({
        url: `${baseAuthServer}/public/pre_login/${type}/code`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: qs.stringify(data),
    }).then(res => {
        return _.get(res, 'data');
    });
}
/**
 * SSO登录信息
 */
export function getSSOLoginCompensationInfo(type, params) {
    return psHttp({
        url: `${baseAuthServer}/public/${type}/compensation/info`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        params,
    }).then(res => {
        return _.get(res, 'data');
    });
}
/**
 * SSO登录绑定、信息补充
 */
export function postSSOLoginCompensation(type, params) {
    params.from = 'account';
    return psHttp({
        url: `${baseAuthServer}/login/${type}/compensation`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        withCredentials: true,
        data: qs.stringify(params),
    }).then(res => {
        return _.get(res, 'data');
    });
}
/**
 * 忘记密码发送重置链接
 */
export function postPublicForget(params) {
    return psHttp({
        url: `${baseAuthServer}/public/forget`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        // withCredentials: true,
        data: qs.stringify(params),
    }).then(res => {
        return _.get(res, 'data');
    });
}
/**
 * 重置密码检查token是否过期
 */
export function getResetPasswordInit(token) {
    return psHttp({
        url: `${baseAuthServer}/public/reset-password/init`,
        method: 'GET',
        params: { token },
    }).then(res => {
        return _.get(res, 'data');
    });
}
/**
 * 激活页初始化
 */
export function getActivationInit(short_code) {
    return psHttp({
        url: `${baseAuthServer}/public/activate/init`,
        method: 'GET',
        params: { short_code },
    }).then(res => {
        return _.get(res, 'data');
    });
}
/**
 * 发送解锁邮件
 */
export function getUnlockUser(email) {
    return psHttp({
        url: `${baseAuthServer}/public/unlock/user`,
        method: 'GET',
        params: { email },
    }).then(res => {
        return _.get(res, 'data');
    });
}
/**
 * 解锁
 */
export function postUnlock(token) {
    return psHttp({
        url: `${baseAuthServer}/public/unlock`,
        method: 'POST',
        params: { token },
    }).then(res => {
        return _.get(res, 'data');
    });
}
/**
 * 出发激活邮件
 */
export function getResendActive(params) {
    return psHttp({
        url: `${baseAuthServer}/public/resend/active`,
        method: 'GET',
        params,
    }).then(res => {
        return _.get(res, 'data');
    });
}
